import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navbar navbar-expand navbar-light p-2 fixed-top bg-primary"
}
const _hoisted_2 = { class: "container-fluid p-0 d-flex justify-content-center" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = {
  key: 0,
  class: "text-white h4 mb-2 mt-2"
}
const _hoisted_5 = {
  key: 1,
  class: "text-white h4 mb-2 mt-2"
}
const _hoisted_6 = {
  key: 2,
  class: "text-white h4 mb-2 mt-2"
}
const _hoisted_7 = {
  key: 1,
  class: "navbar navbar-expand navbar-light bg-light p-1 border-top fixed-bottom"
}
const _hoisted_8 = { class: "container-fluid" }
const _hoisted_9 = { class: "navbar-nav ms-auto d-flex flex-fill justify-content-between" }
const _hoisted_10 = { class: "ff" }
const _hoisted_11 = { class: "ff" }
const _hoisted_12 = { class: "ff" }
const _hoisted_13 = { class: "ff" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_fa = _resolveComponent("fa")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "can-cancel": false,
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.showNav)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.$router.name)
            }, null, 8, _hoisted_3),
            (_ctx.$route.path==='/')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_component_fa, {
                    icon: "home",
                    class: "me-2"
                  }),
                  _createTextVNode("マイページ ")
                ]))
              : _createCommentVNode("", true),
            (_ctx.$route.path==='/exam')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " 健診結果 "))
              : _createCommentVNode("", true),
            (_ctx.$route.path==='/settings')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 設定 "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showNav)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              (_ctx.$route.path!=='/menu')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "nav-link",
                    to: "/menu",
                    "exact-active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_fa, {
                          icon: "home",
                          class: "me-1"
                        }),
                        _createTextVNode("Home")
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$route.path!=='/exam')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    class: "nav-link",
                    to: "/exam",
                    "exact-active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_fa, {
                          icon: "file",
                          class: "me-1"
                        }),
                        _createTextVNode("健診結果")
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$route.path!=='/settings')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    class: "nav-link",
                    to: "/settings",
                    "exact-active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_12, [
                        _createVNode(_component_fa, {
                          icon: "gear",
                          class: "me-1"
                        }),
                        _createTextVNode("設定")
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$route.path!=='/logout')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    class: "nav-link",
                    to: "/logout",
                    "exact-active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_13, [
                        _createVNode(_component_fa, {
                          icon: "right-from-bracket",
                          class: "me-1"
                        }),
                        _createTextVNode("ログアウト")
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "container-fluid",
      style: _normalizeStyle([{"padding-bottom":"50px"}, {'padding-top' : _ctx.showNav ? '50px' : '4px'}])
    }, [
      _createVNode(_component_router_view)
    ], 4)
  ], 64))
}